import { IWhatsappActivity } from '@api/models/analytics.model';
import { IUser } from '@api/models';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { IPhone } from '@api/types/phone.schema';
import { Link } from 'react-router-dom';

interface WhatsappActivityListProps {
    isLoading: boolean;
    activityData: IWhatsappActivity[];
}

const WhatsappActivityList = ({ isLoading, activityData }: WhatsappActivityListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={activityData}
            columns={[{ header: 'Date' }, { header: 'User' }, { header: 'Phone Number' }]}
            renderRow={(row) => (
                <Table.Row key={`${(row.user as IUser)._id}-${row.createdAt}`}>
                    <Table.Cell>{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.user as IUser).client}/users/${(row.user as IUser)._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.user as IUser)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>{(row.phone as IPhone)?.fullNumber}</Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default WhatsappActivityList;
